import { groupBy } from 'lodash';
import { ElasticSearchSortInterface } from '../../core/elasticsearch/model/elastic-search-sort.interface';
import { SortByType } from '../model/sort-by.type';

export function articleFiltersToSearchQuery(activeFilters: any[], nestedPath: string): any[] {
  const queryFilters: any[] = [];
  const groupedFilters = groupBy(activeFilters, 'name');

  Object.entries(groupedFilters).forEach((filterGroup: any) => {
    const filters = filterGroup[1].map((filter: any) => {
      return {
        nested: {
          query: {
            bool: {
              filter: [
                {
                  term: {
                    [`${nestedPath}.sName.keyword`]: {
                      value: filter.name,
                    },
                  },
                },
                {
                  terms: {
                    [`${nestedPath}.sValue.keyword`]: [filter.value],
                  },
                },
              ],
            },
          },
          path: nestedPath,
        },
      };
    });
    queryFilters.push({
      bool: {
        should: [...filters],
      },
    });
  });
  return queryFilters;
}

export function buildArticleFacetedMultiSearchQuery(
  sUrlPath: string,
  queryFilters: any[],
  size = 200,
  page = 0,
  sortBy: SortByType | ElasticSearchSortInterface[] = 'relevance',
  index: string,
) {
  const sort = Array.isArray(sortBy) ? sortBy : sortBy === 'title' ? [{ 'sName.keyword': 'asc' }] : [];

  return [
    { index },
    {
      from: page,
      size: size,
      sort: sort,
      post_filter: {
        bool: {
          filter: {
            bool: {
              must: [
                {
                  bool: {
                    must: [
                      {
                        prefix: {
                          'sUrlPath.keyword': sUrlPath,
                        },
                      },
                    ],
                  },
                },
                ...articleFiltersToSearchQuery(queryFilters, 'oFeatures'),
              ],
            },
          },
        },
      },
      aggs: {
        agg_full: {
          filter: {
            bool: {
              must: [
                {
                  bool: {
                    must: [
                      {
                        prefix: {
                          'sUrlPath.keyword': sUrlPath,
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          aggs: {
            filtered: {
              nested: {
                path: 'oFeatures',
              },
              aggs: {
                attr_name: {
                  terms: {
                    size: 1000,
                    field: 'oFeatures.sName.keyword',
                  },
                  aggs: {
                    feature: {
                      top_hits: {
                        size: 1,
                        _source: {
                          include: ['oFeatures.shtRepresentationType', 'oFeatures.shtWebshopFilter', 'oFeatures.lngFeatureID'],
                        },
                      },
                    },
                    attr_value: {
                      terms: {
                        size: 1000,
                        field: 'oFeatures.sValue.keyword',
                      },
                      aggs: {
                        option: {
                          top_hits: {
                            size: 1,
                            _source: {
                              include: ['oFeatures.shtPos'],
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        agg_filtered: {
          filter: {
            bool: {
              must: [
                {
                  bool: {
                    must: [
                      {
                        prefix: {
                          'sUrlPath.keyword': sUrlPath,
                        },
                      },
                    ],
                  },
                },
                ...articleFiltersToSearchQuery(queryFilters, 'oFeatures'),
              ],
            },
          },
          aggs: {
            filtered: {
              nested: {
                path: 'oFeatures',
              },
              aggs: {
                attr_name: {
                  terms: {
                    size: 1000,
                    field: 'oFeatures.sName.keyword',
                  },
                  aggs: {
                    attr_value: {
                      terms: {
                        size: 1000,
                        field: 'oFeatures.sValue.keyword',
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    { index },
    {
      size: 1,
      query: {
        bool: {
          filter: {
            term: {
              'sUrlPath.keyword': sUrlPath,
            },
          },
        },
      },
    },
  ];
}
